export const ToolsRoutes = {
  HOME: "Tools.Home",
  CATALOG_PRODUCTS: "Tools.Catalog.Products",
  CATALOG_BRANDS: "Tools.Catalog.Brands",
  CATALOG_BRAND: "Tools.Catalog.Brand",
  CATALOG_SALES_CHANNELS: "Tools.Catalog.SalesChannels",
  CATALOG_CHANNELS: "Tools.Catalog.SalesChannels.Channels",
  CATALOG_RETAILERS: "Tools.Catalog.SalesChannels.Retailers",
  CATALOG_RETAILER: "Tools.Catalog.SalesChannels.Retailer",
  COMPETITORS_CATALOG: "Tools.Competitors.Catalog",
  COMPETITORS_CONNECTIONS: "Tools.Competitors.Connections",
  FORECASTING: "Tools.Forecasting",
  NOT_FOUND: "Tools.NotFound",
} as const satisfies Record<string, `Tools.${string}`>;

export type ToolsRouteName = typeof ToolsRoutes[keyof typeof ToolsRoutes];
